/**
 * @property {string} name
 * @property {string} link
 * @property {?(string[])} queryPlaceholders - in case link has some query to dynamically add to the link, such as SN
 */
export class Breadcrumb {
  /**
   * @param {string} name
   * @param {string} link
   * @param {?(string[])} dynamicQuery - in case link has some query to dynamically add to the link, such as SN
   */
  constructor({ name = '', link = '', dynamicQuery = null }) {
    this.name = name;
    this.link = link;
    this.dynamicQuery = dynamicQuery;
  }

  /**
   * Returns an array of string placeholders contained in the name.
   * Placeholders are identified as strings between square brackets, e.g. [SN]
   *
   * @returns {string[]}
   */
  get placeholders() {
    const regex = /\[(\w+)\]/g;
    const placeholderList = [];

    let match;
    // eslint-disable-next-line no-cond-assign
    while ((match = regex.exec(this.name))) {
      placeholderList.push(match[1]);
    }
    return placeholderList;
  }

  /**
   * Checks whether name has any placeholders in it.
   *
   * @returns {boolean}
   */
  get hasPlaceholders() {
    return this.placeholders.length > 0;
  }
}
